(() => {
  let vehicleDataPromise;

  const loadVehicleData = (url) => {
    if (Array.isArray(window.WiperProVehicleData)) {
      return Promise.resolve(window.WiperProVehicleData);
    }
    if (vehicleDataPromise) return vehicleDataPromise;

    vehicleDataPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-wiperpro-vehicle-data-loader]');
      const script = existing || document.createElement('script');

      const resolveData = () => {
        if (Array.isArray(window.WiperProVehicleData)) {
          resolve(window.WiperProVehicleData);
        } else {
          vehicleDataPromise = undefined;
          reject(new Error('Vehicle data asset did not initialise'));
        }
      };

      script.addEventListener('load', resolveData, { once: true });
      script.addEventListener('error', () => {
        vehicleDataPromise = undefined;
        reject(new Error('Vehicle data asset failed to load'));
      }, { once: true });

      if (!existing) {
        script.src = url;
        script.async = true;
        script.dataset.wiperproVehicleDataLoader = 'true';
        document.head.appendChild(script);
      }
    });

    return vehicleDataPromise;
  };

  class HomepageCarFilter {
    constructor(root) {
      this.root = root;
      this.makeSelect = root.querySelector('[data-car-make]');
      this.modelSelect = root.querySelector('[data-car-model]');
      this.submitButton = root.querySelector('[data-car-submit]');
      this.fallbackLink = root.querySelector('a.link');
      this.vehicleData = [];

      if (!this.makeSelect || !this.modelSelect || !this.submitButton) return;
      this.makeSelect.addEventListener('change', () => this.updateModels());
      this.submitButton.addEventListener('click', () => this.submit());
      this.initialise();
    }

    async initialise() {
      try {
        this.vehicleData = await loadVehicleData(this.root.dataset.vehicleDataUrl);
        this.populateMakes();
      } catch (error) {
        this.makeSelect.replaceChildren(new Option('Select make', ''));
        this.makeSelect.disabled = true;
      }
    }

    populateMakes() {
      const makes = [...new Set(this.vehicleData.map((vehicle) => vehicle.make))]
        .sort((a, b) => a.localeCompare(b));
      this.makeSelect.replaceChildren(new Option('Select make', ''));
      makes.forEach((make) => this.makeSelect.add(new Option(make, make)));
      this.makeSelect.disabled = false;

      const requestedMake = this.root.dataset.preselectedMake || '';
      const matchedMake = makes.find((make) => make.toLocaleLowerCase() === requestedMake.toLocaleLowerCase());
      if (matchedMake) {
        this.makeSelect.value = matchedMake;
        this.updateModels();
      }
    }

    updateModels() {
      const make = this.makeSelect.value;
      const models = [...new Set(
        this.vehicleData.filter((vehicle) => vehicle.make === make).map((vehicle) => vehicle.model)
      )].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

      this.modelSelect.replaceChildren(new Option('Select model', ''));
      models.forEach((model) => this.modelSelect.add(new Option(model, model)));
      this.modelSelect.disabled = models.length === 0;
      window.WiperProHomepageCarFilterValidation?.clearValidation?.(this.root);
    }

    submit() {
      const make = this.makeSelect.value;
      const model = this.modelSelect.value;
      if (!make || !model) {
        window.WiperProHomepageCarFilterValidation?.showFirstIncompleteField?.(this.root);
        return;
      }

      const vehicle = this.vehicleData.find((item) => item.make === make && item.model === model);
      if (vehicle?.slug) {
        window.location.assign(`${this.root.dataset.productsRoot}${encodeURIComponent(vehicle.slug)}`);
      } else if (this.fallbackLink) {
        window.location.assign(this.fallbackLink.href);
      }
    }
  }

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-homepage-car-filter]').forEach((root) => {
      if (root.dataset.homepageCarFilterReady === 'true') return;
      root.dataset.homepageCarFilterReady = 'true';
      new HomepageCarFilter(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
